import { render } from "./WorkstationSection.vue?vue&type=template&id=767e1a44&scoped=true"
import script from "./WorkstationSection.vue?vue&type=script&lang=js"
export * from "./WorkstationSection.vue?vue&type=script&lang=js"

import "./WorkstationSection.vue?vue&type=style&index=0&id=767e1a44&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767e1a44"]])

export default __exports__